import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestBase } from './request-base';

@Injectable()
export class CapsuleService extends RequestBase {
    BasePath = 'api/capsule';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    GetCapsuleTags(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetCapsuleTags', this.options);
    }

    GetLatestVersions(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetLatestVersions', this.options);
    }

    GetOverriddenInfos(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetOverriddenInfos', this.options);
    }

    DeleteOverridden(request: any): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + '/DeleteOverridden', request, this.options);
    }

    GetCapsuleContent(info: any): Observable<any> {
        return this.http.post(this.API_BASE_URL + this.BasePath + '/GetCapsuleContent', info, this.options);
    }

    SaveCapsuleContentSaveData(data: any): Observable<any> {
        return this.http.post(this.API_BASE_URL + this.BasePath + '/SaveCapsuleContentSaveData', data, this.options);
    }
}
